module.exports = __webpack_public_path__ + "static/media/sort-icon.04e87c8d.svg";